import React from 'react';
import { Button, Icon, Form, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';


export default class HRFilters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: null,
            lastName: null,
            jmbg: null,
        };
        this.onFilterData = this.onFilterData.bind(this);
    }


    onFilterData() {
        if (!this.state.jmbg && !this.state.firstName && !this.state.lastName) {
            toast('Morate unijeti po čemu želite filtrirati podatke!');
        } else {
            this.props.onFilterData(
                this.state.jmbg,
                this.state.firstName,
                this.state.lastName,
            );
        }
    }


    render() {
        return (
            <div className={!this.props.noSegment && 'ui clearing segment'}>
                {this.props.noSegment && <div><br /><br /><br /></div>}
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Prezime</label>
                            <input
                                value={this.state.lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                name="lastName"
                                placeholder="Unesite prezime"
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Ime</label>
                            <input
                                value={this.state.firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                name="firstName"
                                placeholder="Unesite ime"
                            />
                        </Form.Field>

                       <Form.Field>
                            <label>JMBG</label>
                            <input
                                value={this.state.jmbg}
                                onChange={(e) => this.setState({ jmbg: e.target.value })}
                                name="jmbg"
                                placeholder="Unesite jmbg"
                            />
                        </Form.Field>
                    </Form.Group>

                    <Button basic="true" color="blue" floated='right' onClick={this.props.filtersOff}>Odustani
                    </Button>
                    <Button color="blue" floated='right' onClick={this.onFilterData}>Filtriraj
                    </Button>
                </Form>
                {this.props.noSegment && <div><br /><br /><br /></div>}

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/HRFilters.js